import { createSlice } from '@reduxjs/toolkit'
import { REHYDRATE } from 'redux-persist'

const initialState = {
  isFillUserInfoModalChecked: false,
  authFromLocalbondChecked: false,
  searchRecord: {
    articleRecords: [],
    albumRecords: [],
    venderRecords: [],
  },
  navigateInfo: {
    // 從哪個文章、相簿、廠商etc引導至下單頁
    id: null,
    type: '',
  },
  preselectVender: null,
}

export const cacheSlice = createSlice({
  name: 'cache',
  initialState: initialState,
  reducers: {
    setIsFillUserInfoModalChecked: (state, action) => {
      state.isFillUserInfoModalChecked = action.payload
    },
    setAuthFromLocalbondChecked: (state, action) => {
      state.authFromLocalbondChecked = action.payload
    },

    addSearchRecord: (state, action) => {
      const newRecord = action.payload
      const key = `${newRecord.type}Records`
      const newRecordExist = state.searchRecord[key]?.find(
        (record) => record.keyword === newRecord.keyword
      )
      if (!newRecordExist) {
        if (state.searchRecord[key]?.length === 5) {
          state.searchRecord[key].pop()
        }
        state.searchRecord[key]?.unshift(newRecord)
      }
    },
    removeAllSearchRecord: (state, action) => {
      state.searchRecord = initialState.searchRecord
    },

    setNavigateInfo: (state, action) => {
      const { id, type } = action.payload
      state.navigateInfo = { id, type }
    },
    clearNavigateInfo: (state, action) => {
      state.navigateInfo = initialState.navigateInfo
    },

    setPreselectVender: (state, action) => {
      state.preselectVender = action.payload
    },
    clearPreselectVender: (state, action) => {
      state.preselectVender = null
    },
  },

  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      // TODO: control rehydration here

      // migrate old persist data
      const newState = action.payload
      if (newState && newState?.cache?.searchRecord === undefined) {
        newState.cache.searchRecord = initialState.searchRecord
      }
    })
  },
})

export const selectIsFillUserInfoModalChecked = (state) =>
  state.cache.isFillUserInfoModalChecked
export const selectAuthFromLocalbondChecked = (state) =>
  state.cache.authFromLocalbondChecked

export const selectArticleSearchRecords = (state) =>
  state.cache.searchRecord.articleRecords
export const selectAlbumSearchRecords = (state) =>
  state.cache.searchRecord.albumRecords
export const selectVenderSearchRecords = (state) =>
  state.cache.searchRecord.venderRecords

export const selectNavigateInfo = (state) => state.cache.navigateInfo

export const selectPreselectVender = (state) => state.cache.preselectVender

export const {
  setIsFillUserInfoModalChecked,
  setAuthFromLocalbondChecked,
  addSearchRecord,
  removeAllSearchRecord,
  setNavigateInfo,
  clearNavigateInfo,
  setPreselectVender,
  clearPreselectVender,
} = cacheSlice.actions

export default cacheSlice.reducer
